import { useState } from "react";
import { Milestone, MilestoneFormProps } from "../../types";
export default function MilestoneForm({ milestone, onRemove, onSave }: MilestoneFormProps) {
  const [formData, setFormData] = useState(milestone);
  const [isModified, setIsModified] = useState(false);

  const handleChange = (key: keyof Milestone, value: any) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
    setIsModified(true);
  };

  return (
    <div className="bg-white p-4 rounded-lg shadow-md border">
      {/* Header */}
      <div className="flex justify-between items-center">
        <h2 className="text-lg font-semibold">Milestone {milestone.order}</h2>
        <button className="text-red-500 hover:text-red-700" onClick={() => onRemove(milestone.order!)}>
          ❌ Remove
        </button>
      </div>

      {/* Milestone Reach */}
      <div className="mt-3">
        <label className="block text-sm font-medium">Milestone reached after:</label>
        <div className="flex items-center gap-2">
          <input
            type="number"
            value={formData.milestone_reach?.after_hire?.amount || ""}
            onChange={(e) =>
              handleChange("milestone_reach", { after_hire: { amount: Number(e.target.value), unit: "Days" } })
            }
            className="border rounded px-3 py-1 w-20"
          />
          <span className="text-sm">days after hire.</span>
        </div>
      </div>

      {/* Accrual */}
      <div className="mt-4">
        <label className="block text-sm font-medium">Employees accrue:</label>
        <div className="flex items-center gap-2">
          <input
            type="number"
            value={formData.accrual?.amount || ""}
            onChange={(e) => handleChange("accrual", { ...formData.accrual, amount: Number(e.target.value) })}
            className="border rounded px-3 py-1 w-20"
          />
          <span className="text-sm">hours per</span>
          <select
            value={formData.accrual?.unit || "Monthly"}
            onChange={(e) => handleChange("accrual", { ...formData.accrual, unit: e.target.value })}
            className="border rounded px-2 py-1"
          >
            <option value="Daily">Daily</option>
            <option value="Weekly">Weekly</option>
            <option value="Monthly">Monthly</option>
            <option value="Yearly">Yearly</option>
          </select>
        </div>
      </div>

      {/* Cap Override */}
      <div className="mt-4">
        <label className="block text-sm font-medium">Cap on accrual balance?</label>
        <div className="flex gap-3 mt-1">
          <label className="flex items-center gap-1">
            <input
              type="radio"
              name={`cap-${milestone.order}`}
              checked={!formData.cap_override?.enabled}
              onChange={() => handleChange("cap_override", { enabled: false, new_cap: 0 })}
            />
            No, they continue accruing.
          </label>
          <label className="flex items-center gap-1">
            <input
              type="radio"
              name={`cap-${milestone.order}`}
              checked={formData.cap_override?.enabled || false}
              onChange={() => handleChange("cap_override", { enabled: true, new_cap: 40 })}
            />
            Yes, stop at a certain balance.
          </label>
        </div>

        {/* Input for cap balance if Yes is selected */}
        {formData.cap_override?.enabled && (
          <input
            type="number"
            placeholder="Enter cap balance"
            value={formData.cap_override.new_cap || ""}
            onChange={(e) => handleChange("cap_override", { ...formData.cap_override, new_cap: Number(e.target.value) })}
            className="border rounded px-3 py-1 mt-2 w-24"
          />
        )}
      </div>

      {/* Carryover Limit */}
      <div className="mt-4">
        <label className="block text-sm font-medium">Can unused time be carried over?</label>
        <div className="flex gap-3 mt-1">
          <label className="flex items-center gap-1">
            <input
              type="radio"
              name={`carryover-${milestone.order}`}
              checked={!formData.carryover_limit?.unlimited}
              onChange={() => handleChange("carryover_limit", { unlimited: false, upto_hours: 10 })}
            />
            No, use it or lose it.
          </label>
          <label className="flex items-center gap-1">
            <input
              type="radio"
              name={`carryover-${milestone.order}`}
              checked={formData.carryover_limit?.unlimited || false}
              onChange={() => handleChange("carryover_limit", { unlimited: true, upto_hours: 0 })}
            />
            Yes, time can be carried over.
          </label>
        </div>

        {/* Input for carryover limit if Yes is selected */}
        {!formData.carryover_limit?.unlimited && (
          <input
            type="number"
            placeholder="Max carryover"
            value={formData.carryover_limit?.upto_hours || ""}
            onChange={(e) =>
              handleChange("carryover_limit", { ...formData.carryover_limit, upto_hours: Number(e.target.value) })
            }
            className="border rounded px-3 py-1 mt-2 w-24"
          />
        )}
      </div>

      {/* Save Button */}
      {isModified && (
        <button
          onClick={() => {
            onSave(formData);
            setIsModified(false);
          }}
          className="mt-4 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Save Changes
        </button>
      )}
    </div>
  );
}
